export default __webpack_public_path__ + "static/media/automobile.b62d0025.svg";